import isExternalIdentifierValid from 'Domain/User/Helper/ExternalIdentifierValidator';
import { isValidIBAN } from 'Domain/User/Helper/IbanValidator';

import {
  Constraint,
  ConstraintConfig,
  ConstraintMessage,
  PresetConstraint,
} from './FormEntities';

const moment = require('moment');

const constraintsConfig: Record<PresetConstraint, ConstraintConfig> = {
  ageDate: {
    message: {
      name: 'date_max_year',
      params: {
        year: '100',
      },
    },
    validation: (value: string, values: any) => {
      if (!value) {
        return true;
      }
      const date = moment(value, 'YYYY-MM-DD');
      const years = moment().diff(date, 'years');
      return years < 100;
    },
  },

  iban: {
    message: 'invalid_iban',
    validation: (value: string, values: any) => isValidIBAN(value),
  },
  externalIdentifier: {
    message: (values: any) => ({
      name: values.country + '_external_identifier_format',
      params: {},
    }),
    validation: (value: string, values: any) =>
      isExternalIdentifierValid(value, values.country),
  },
  email: {
    message: 'email',
    validation: (val: string) =>
      val === '' ||
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val),
  },
  required: {
    message: 'required',
    validation: (val: any) => val !== '',
  },
  isTrue: {
    message: 'required',
    validation: (val: any) => val !== false,
  },
};

export default function validateField(
  name: string,
  value: any,
  values: any,
  constraints: Record<string, Array<Constraint>>,
) {
  const fieldErrors: Array<ConstraintMessage> = [];
  if (name in constraints) {
    constraints[name].forEach((constraint: Constraint | ConstraintConfig) => {
      let constraintObject;
      if (typeof constraint === 'string' && constraint in constraintsConfig) {
        constraintObject = constraintsConfig[constraint];
      } else if (typeof constraint === 'object') {
        constraintObject = constraint;
      }
      if (constraintObject && !constraintObject.validation(value, values)) {
        if (typeof constraintObject.message === 'function') {
          fieldErrors.push(constraintObject.message(values));
        } else {
          fieldErrors.push(constraintObject.message);
        }
      }
    });
  }

  return fieldErrors;
}
